
import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { FileText } from 'lucide-react';
import { AdminDocument } from '@/types/admin.types';
import AdminDocumentViewerDialog from '../documents/AdminDocumentViewerDialog';

interface AdminDocumentsTabProps {
  documents: AdminDocument[];
}

const AdminDocumentsTab = ({ documents }: AdminDocumentsTabProps) => {
  const [selectedDocument, setSelectedDocument] = useState<AdminDocument | null>(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleViewDocument = (document: AdminDocument) => {
    setSelectedDocument(document);
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
    setSelectedDocument(null);
  };

  return (
    <>
      <Card>
        <CardHeader>
          <CardTitle className="text-xl">Documents</CardTitle>
          <CardDescription>
            Uploaded documents and files
          </CardDescription>
        </CardHeader>
        <CardContent>
          {documents.length === 0 ? (
            <div className="text-center py-6 text-muted-foreground">
              <FileText className="h-8 w-8 mx-auto mb-2 opacity-50" />
              <p>No documents uploaded</p>
            </div>
          ) : (
            <div className="space-y-3">
              {documents.map((doc) => (
                <div key={doc.id} className="flex items-center justify-between p-3 border rounded-md">
                  <div className="flex items-center">
                    <FileText className="h-5 w-5 mr-3 text-muted-foreground" />
                    <div>
                      <p className="text-sm font-medium">{doc.name}</p>
                      <p className="text-xs text-muted-foreground">
                        {(doc.size / 1024 / 1024).toFixed(2)} MB • {doc.documentType}
                      </p>
                    </div>
                  </div>
                  <Button 
                    variant="ghost" 
                    size="sm" 
                    onClick={() => handleViewDocument(doc)}
                  >
                    View
                  </Button>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>

      <AdminDocumentViewerDialog 
        document={selectedDocument}
        isOpen={isDialogOpen}
        onClose={handleCloseDialog}
      />
    </>
  );
};

export default AdminDocumentsTab;
